import React from "react";
import { Box, Button } from "@mui/material";

const ContactViewToggleButton = ({ vueFiches, setVueFiches, isMobile, t }) => (
  <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 2 }}>
    <Button
      variant="contained"
      onClick={() => setVueFiches(!vueFiches)}
      sx={{
        backgroundColor: "#e4dcd2 !important",
        color: "white",
        fontWeight: "bold",
        fontSize: isMobile ? "0.75rem" : "0.9rem",
        minHeight: "38px",
        width: isMobile ? "auto" : "100px",
        minWidth: "fit-content",
        maxWidth: "100%",
        paddingX: isMobile ? 2 : 4,
        paddingY: isMobile ? 0.8 : 2.5,
        borderRadius: isMobile ? 1.5 : 2,
        boxShadow: 3,
        "&:hover": { backgroundColor: "#e4dcd2" }
      }}
    >
      {isMobile
        ? vueFiches ? "📋" : "🗂️"
        : vueFiches ? t("ShowTable") : t("ShowCards")}
    </Button>
  </Box>
);

export default ContactViewToggleButton; // ✅ indispensable
